import Vue from 'vue';
import VueRouter from 'vue-router';
import User from '@/components/user-component/User.vue';
import UserHome from '@/components/user-component/UserHome.vue';
import UserProfile from '@/components/user-component/UserProfile.vue';
import UserPosts from '@/components/user-component/UserPosts.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/user/:userId',
        component: User,
        name: 'user',
        children: [
            {
                // UserHome will be rendered inside User's <router-view>
                // when /user/:id is matched
                path: '',
                component: UserHome
            },
            {
                // UserProfile will be rendered inside User's <router-view>
                // when /user/:id/profile is matched
                path: 'profile',
                component: UserProfile
            },
            {
                // UserPosts will be rendered inside User's <router-view>
                // when /user/:id/posts is matched
                path: 'posts',
                component: UserPosts
            }
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router;
